
import { ComboBox, IComboBoxOption, Panel, PanelType } from "@fluentui/react";
import { ComboBoxComponent } from "../../../../components/comboBox/ComboBoxComponent";
import { IFilter2, IT, keyType, textType } from "../useEstadoEquipo";
import { PanelHeader } from "../../../../components/Panel/PanelHeader";
import { PanelFooter } from "../../../../components/Panel/PanelFooter";
import { UseComboUbicacion } from "../../../../hooks/auxiliar/combo/UseComboUbicacion";
import { IOpenPanel } from "../../../../Interfaces/IPanel";
import { useComboEstadoEquipo } from "../../../../hooks/auxiliar/combo/useComboEstadoEquipo";
import { UseComboEquipo } from "../../../../hooks/auxiliar/combo/UseComboEquipo";
import { useComboTipoEquipos } from "../../../../hooks/auxiliar/combo/UseComboTipoEquipo";
import { UseComboRegion } from "../../../../hooks/auxiliar/combo/UseComboRegion";
import { ComboBoxMultiComponent } from "../../../../components/comboBox/ComboBoxMultiComponent";
export interface IPanelEstadoEquipo extends IOpenPanel {
  reload: () => void
  equipoId?: string,
  isOpen: boolean;
  resetFilter2: () => void;
  buscar: () => void;
  onDismiss: () => void;
  filter2: IFilter2
  onChangeComboFilter?: (data: IT) => void
}
interface IR {
  data?: IComboBoxOption,
  key: keyType,
  text: textType
}

interface IR {
  data?: IComboBoxOption,
  key: keyType,
  text: textType
}

export const PanelFiltroEstadoEquipo = ({
  isOpen,
  resetFilter2,
  onChangeComboFilter,
  onChangeComboFilterMultiple,
  filter2,
  buscar,
  onDismiss
}) => {
  const { dataComboUbicacion, filterCombo, setFilterCombo } = UseComboUbicacion({ comboNivel: 3, isOpen: isOpen })
  const { dataComboEstado, setfilterEstado, filterEstado } = useComboEstadoEquipo(isOpen)
  const { dataComboEquipo, setFilterEquipo, filterEquipo } = UseComboEquipo({ isOpen, equipoAuxiliar: true });
  const { dataComboTipoE, setFilterTipoE, filterTipoE } = useComboTipoEquipos({ isOpen, equipoAuxiliar: true });
  const { dataComboRegion, filterComboRegion, setFilterComboRegion } = UseComboRegion({ comboNivel: 2, isOpen: isOpen })

  const handleOnChange = ({ data, key, text }: IR) => {
    if (data) {
      onChangeComboFilter({
        key,
        keyValue: `${data.key}`,
        text,
        textValue: data.text
      })
    }
  };
  

  return (
    <Panel
      type={PanelType.smallFixedFar}
      onRenderHeader={() =>
        <PanelHeader
          textHeader="Filtrar Equipos"
          subTextHeader={`Búsqueda Avanzada`}
        />
      }
      onRenderFooter={() =>
        <PanelFooter
          texto="Buscar"
          texto2={"Limpiar"}
          onClick={buscar}
          disableButton={false}
          onDismiss={resetFilter2}
        />
      }
      isFooterAtBottom
      isOpen={isOpen}
      onDismiss={onDismiss}
    >
      <div className="ms-Grid" dir="ltr">

        <ComboBoxComponent
          text={"Regiones"}
          selectedKey={filter2.regionId}
          placeholder="Seleccione la Región"
          data={dataComboRegion}
          onChange={(value) => {
            setFilterComboRegion({
              ...filterComboRegion,
              search: value
            })
          }}
          onOptionSelect={(event, option) => {
            handleOnChange({
              data: option, key: 'regionKey', text: 'regionText'
            })
          }}
          defaultSelectedOptions={[{
            key: filter2.regionKey,
            text: filter2.regionText
          }]}
        />
        <ComboBoxComponent
          text={"Ubicaciones"}
          selectedKey={filter2.ubicacionId}
          placeholder="Seleccione Ubicación"
          data={dataComboUbicacion}
          onChange={(value) => {
            setFilterCombo({
              ...filterCombo,
              search: value
            })
          }}
          onOptionSelect={(event, option) => {
            handleOnChange({
              data: option, key: 'ubicacionKey', text: 'ubicacionText'
            })
          }}
          defaultSelectedOptions={[{
            key: filter2.ubicacionKey,
            text: filter2.ubicacionText
          }]}
        />
        <ComboBoxMultiComponent
          text={"Estado"}
          selectedKeys={filter2.estadoKey}
          placeholder="Seleccione Estado"
          data={dataComboEstado} 
          onOptionSelect={(event,datafprm,option)=>{
            onChangeComboFilterMultiple({
              estadoKey:"estadoKey",
              keys: datafprm.map((item)=>item.key),
              estadoText:"estadoText",
              texts: datafprm.map((item)=>item.text)
            })
          }}   
        />

        <ComboBoxComponent
          text={"Equipo"}
          selectedKey={filter2.equipoId}
          placeholder="Seleccione Equipo"
          data={dataComboEquipo}
          onChange={(value) => {
            setFilterEquipo({
              ...filterEquipo,
              search: value
            })
          }}
          onOptionSelect={(event, option) => {
            handleOnChange({
              data: option, key: 'equipoKey', text: 'equipoText'
            })
          }}
          defaultSelectedOptions={[{
            key: filter2.equipoKey,
            text: filter2.equipoText
          }]}
        />
        <ComboBoxComponent
          text={"Tipo Equipo"}
          selectedKey={filter2.tipoEquipoId}
          placeholder="Seleccione Tipo Equipo"
          data={dataComboTipoE}
          onChange={(value) => {
            setFilterTipoE({
              ...filterTipoE,
              search: value
            })
          }}
          onOptionSelect={(event, option) => {
            handleOnChange({
              data: option, key: 'tipoEquipoKey', text: 'tipoEquipoText'
            })
          }}
          defaultSelectedOptions={[{
            key: filter2.tipoEquipoKey,
            text: filter2.tipoEquipoText
          }]}
        />
      </div>
    </Panel >
  );
};